import { AssetSelectionGrid } from '@client/components/ltc-financial-planning/AssetSelectionGrid';
import { setSelectedAccountTypes } from '@client/model/ltcFinancialPlanningModel';
import {
  selectClient,
  selectLtcFinancialPlanningSelectedAccountTypes,
} from '@client/model/selectors';
import { AccountType } from '@client/util/constants';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StepContentProps } from '../types';

export function AssetSelectionStep({ navigation }: StepContentProps) {
  const dispatch = useDispatch();
  const selectedAccountTypes = useSelector(selectLtcFinancialPlanningSelectedAccountTypes);
  const client = useSelector(selectClient);

  // Check if self-funding sources already exist
  const selfFunding = client.multipleFundingSources?.selfFunding || {};
  const hasSelfFundingSources = Object.keys(selfFunding).length > 0;

  // Redirect to asset-details if self-funding sources already exist
  useEffect(() => {
    if (hasSelfFundingSources) {
      navigation.goToStep('asset-details');
    }
  }, [hasSelfFundingSources, navigation]);

  // Toggle asset selection
  const handleToggleAsset = useCallback(
    (accountType: AccountType) => {
      const currentSelected = selectedAccountTypes || [];
      if (currentSelected.includes(accountType)) {
        dispatch(setSelectedAccountTypes(currentSelected.filter(a => a !== accountType)));
      } else {
        dispatch(setSelectedAccountTypes([...currentSelected, accountType]));
      }
    },
    [dispatch, selectedAccountTypes],
  );

  return (
    <div className="py-8 text-center">
      <h1 className="text-2xl font-bold text-gray-900 md:text-3xl">What assets do you have?</h1>
      <p className="mx-auto mt-3 max-w-2xl text-base text-gray-700">
        Select all the accounts and assets you currently own. We'll use this to assess your
        long-term care coverage capacity.
      </p>
      <AssetSelectionGrid
        className="mx-auto mt-8 max-w-3xl"
        selectedAssets={selectedAccountTypes as AccountType[]}
        onToggleAsset={handleToggleAsset}
      />
    </div>
  );
}
